import AncillaryUIModel from './ancillary';

class TravelerAncillaryUIModel {
  constructor({
    ancillary = {},
    benefitCodeId = null,
    legCode = null,
    options = [],
    quantity = 0,
    segmentCode = null,
  } = {}) {
    this.ancillary = new AncillaryUIModel(ancillary);
    this.benefitCodeId = benefitCodeId;
    this.legCode = legCode;
    this.options = options;
    this.quantity = quantity;
    this.segmentCode =  segmentCode;
    this.isPaid = ancillary.redeemed ? true : false;
  }

  getTotal() {
    if (this.ancillary.hasOwnProperty('ancillaryOffer')) {
      return this.ancillary.ancillaryOffer.ancillary.getTotal();
    } else {
      return this.ancillary.getTotal();
    }
  }

  getTotalPoints() {
    if (this.ancillary.hasOwnProperty('ancillaryOffer')) {
      return this.ancillary.ancillaryOffer.ancillary.getTotalPoints();
    } else {
      return this.ancillary.getTotalPoints();
    }
  }

  getTotalPerLeg(legCode) {
    return this.ancillary.getTotalPerLeg(legCode);
  }

  getTotalCPPointsPerLeg(legCode) {
    return this.ancillary.getTotalCPPointsPerLeg(legCode);
  }

  getTaxDetails() {
    return this.ancillary.getTaxDetails();
  }

  getType() {
    return this.ancillary.type === '029' ? 'CBX' : this.ancillary.type;
  }

  getGroupCode() {
    return this.ancillary.groupCode;
  }

  toApi() {
    if (this.ancillary.ancillaryOffer && this.ancillary.ancillaryOffer.ancillary && this.ancillary.ancillaryOffer.ancillary.type === 'UPG') {
      return  this.ancillary.toApi();
    } else {
      return {
        '_meta':{
          'class':'TravelerAncillary',
        },
        'ancillary': this.ancillary.toApi(),
        'quantity': this.quantity,
        'options': this.options,
        'legCode': this.legCode,
        'benefitCodeId': this.benefitCodeId,
        'segmentCode' : this.segmentCode,
      };
    }
  }
}

export default TravelerAncillaryUIModel;
